import backendConfig from "../config/backendConfig.ts";
import store from "../store/store.ts";

type Result<T = {}> = ({ success: true } & T) | { success: false; error: string; status?: number };

const url = (path: string) => `${backendConfig.API_BASE_URL}${backendConfig.ENDPOINTS.ADMIN}${path}`;

export const adminHeaders = (): Record<string, string> => {
  const token = store.getState().auth?.token;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const handleUnauthorized = (status: number) => {
  if (status !== 401) return;
  store.dispatch({ type: "LOGOUT" });
  window.location.assign("/admin-login?expired=1");
};

const request = async <T,>(path: string, init: RequestInit = {}): Promise<Result<T>> => {
  try {
    const response = await fetch(url(path), {
      ...init,
      headers: { "Content-Type": "application/json", ...adminHeaders(), ...(init.headers || {}) },
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok || !body.success) {
      return { success: false, error: body.error || `HTTP ${response.status}`, status: response.status };
    }
    return body;
  } catch (error: any) {
    return { success: false, error: error.message || "Could not reach the server." };
  }
};

export const loginAdmin = (username: string, password: string) =>
  request<{ token: string; username: string }>("/login", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  });

export const getAdminProfile = async () => {
  const result = await request<{ username: string; passwordChangedAt: string }>("/me");
  if (!result.success) handleUnauthorized(result.status || 0);
  return result;
};

export const updateAdminCredentials = async (input: {
  currentPassword: string;
  username: string;
  newPassword?: string;
}) => {
  const result = await request<{ token: string; username: string }>("/credentials", {
    method: "PUT",
    body: JSON.stringify(input),
  });
  if (!result.success && result.status === 401) handleUnauthorized(401);
  return result;
};
